import { useEffect, useState } from 'react'

/* Styles */
import style from './SchoolRecordForm.module.css'

/* Libraries */
import { useForm } from 'react-hook-form'

/* Apis */
import { getSchoolRecordInfoApi } from '../../../api/schoolRecord'
import { adminGetSchoolRecordVer2Api } from '../../../api/admin/schoolRecord'

/* Utils */
import { swalErrorAlert } from '../../../utils/swal/swal'
import StudentInformationTable from './write/StudentInformationTable'
import AcademicRecordTable from './write/AcademicRecordTable'
import GradingScale from './write/GradingScale'
import TeacherCommentsTable from './write/TeacherCommentsTable'
import EducationalBackgroundTable from './write/EducationalBackgroundTable'
import AttendanceRecordTable from './write/AttendanceRecordTable'
import AwardsTable from './write/AwardsTable'
import ExtracurricularTable from './write/ExtracurricularTable'
import ExploratoryTable from './write/ExploratoryTable'
import VolunteerTable from './write/VolunteerTable'
import BehavioralRemarkTable from './write/BehavioralRemarkTable'
import TeacherCommentsSignBox from './write/TeacherCommentsSignBox'
import AdditionalComments from './write/AdditionalComments'


const SchoolRecordVer2ReadForm = ({ schoolRecordId, pdfRef, isAdmin = false }) => {

    /* States */
    const [schoolRecordInfo, setSchoolRecordInfo] = useState(null)

    /* React Hook Form */
    const { register, reset, control } = useForm()

    /* UseEffect */
    useEffect(() => {
        const getSchoolRecordInfo = async (schoolRecordId) => {
            if (!schoolRecordId) {
                setSchoolRecordInfo(null)
                return
            }

            try {
                let response;
                if (isAdmin) {
                    response = await adminGetSchoolRecordVer2Api(schoolRecordId)
                } else {
                    response = await getSchoolRecordInfoApi(schoolRecordId)
                }

                if (response.status === 200) {
                    const data = response.data?.resData || null
                    setSchoolRecordInfo(data)
                }
                else {
                    setSchoolRecordInfo(null)
                }

            } catch (error) {
                console.error(error);
                setSchoolRecordInfo(null)
                swalErrorAlert('생활기록부 조회 실패', '생활기록부 데이터를 불러오는 도중에 에러가 발생했습니다.')
                return
            }
        }

        getSchoolRecordInfo(schoolRecordId)
    }, [schoolRecordId])


    useEffect(() => {
        reset(schoolRecordInfo)

    }, [schoolRecordInfo])

    return (
        <form id='schoolRecordForm'>
            <div className="mb-3">
                <label className="form-label pb-3">제목</label>
                <div className='pb-2 font-weight-bold'>{schoolRecordInfo?.title || ''}</div>
            </div>
            <hr className='divider-row' />

            <div className='py-3'>
                <label className="form-label pb-3">생활기록부</label>
                <div className={style.schoolRecordWrap}>
                    <div className={style.schoolRecord} ref={pdfRef}>
                        <div className={style.topTitleWrap}>
                            <h1 className={style.topTitle}>Certificate of School Record</h1>
                        </div>

                        {/* 1. Student Information */}
                        <div className={`${style.section} student-info`}>
                            <h2 className={style.sectionTitle}>1. Student Information</h2>

                            <div className={style.sectionContent}>
                                <StudentInformationTable register={register} isRead={true} />
                            </div>
                        </div>

                        {/* 2. Academic Record */}
                        <div className={`${style.section} academic-record`}>
                            <h2 className={style.sectionTitle}>2. Academic Record</h2>

                            <div className={style.sectionContent}>
                                <AcademicRecordTable register={register} isRead={true} />
                                <GradingScale />
                            </div>
                        </div>

                        {/* 3. Teacher’s comments on subjects (G10-1) */}
                        <div className={`${style.section} teacher-comments g10-1`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G10-1)</h2>
                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={10} semester={1} isRead={true} />
                                <TeacherCommentsSignBox isRead={true} />
                            </div>
                        </div>
                        {/* 3. Teacher’s comments on subjects (G10-2) */}
                        <div className={`${style.section} teacher-comments g10-2`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G10-2)</h2>
                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={10} semester={2} isRead={true} />
                                <TeacherCommentsSignBox isRead={true} />
                            </div>
                        </div>
                        {/* 3. Teacher’s comments on subjects (G11-1) */}
                        <div className={`${style.section} teacher-comments g11-1`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G11-1)</h2>
                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={11} semester={1} isRead={true} />
                                <TeacherCommentsSignBox isRead={true} />
                            </div>
                        </div>
                        {/* 3. Teacher’s comments on subjects (G11-2) */}
                        <div className={`${style.section} teacher-comments g11-2`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G11-2)</h2>
                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={11} semester={2} isRead={true} />
                                <TeacherCommentsSignBox isRead={true} />
                            </div>
                        </div>
                        {/* 3. Teacher’s comments on subjects (G12-1) */}
                        <div className={`${style.section} teacher-comments g12-1`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G12-1)</h2>
                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={12} semester={1} isRead={true} />
                                <TeacherCommentsSignBox isRead={true} />
                            </div>
                        </div>
                        {/* 3. Teacher’s comments on subjects (G12-2) */}
                        <div className={`${style.section} teacher-comments g12-2`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G12-2)</h2>
                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={12} semester={2} isRead={true} />
                                <TeacherCommentsSignBox isRead={true} />
                            </div>
                        </div>


                        {/* 4. Educational Background */}
                        <div className={`${style.section} educational-background`}>
                            <h2 className={style.sectionTitle}>4. Educational Background</h2>

                            <div className={style.sectionContent}>
                                <EducationalBackgroundTable register={register} isRead={true} />
                            </div>
                        </div>


                        {/* 5. Attendance Record */}
                        <div className={`${style.section} attendance`}>
                            <h2 className={style.sectionTitle}>5. Attendance Record</h2>

                            <div className={style.sectionContent}>
                                <AttendanceRecordTable register={register} isRead={true} />
                            </div>
                        </div>


                        {/* 6. Awards & Certificate of Appointment  */}
                        <div className={`${style.section} awards`}>
                            <h2 className={style.sectionTitle}>6. Awards & Certificate of Appointment</h2>

                            <h2 className={style.sectionTitle}>6-1. &lt;in school&gt; Awards</h2>
                            <div className={style.sectionContent}>
                                <AwardsTable register={register} control={control} name={`awards.inSchool`} isRead={true} type={'awards'} />
                            </div>

                            <h2 className={style.sectionTitle}>6-2. &lt;out of school&gt; Awards</h2>
                            <div className={style.sectionContent}>
                                <AwardsTable register={register} control={control} name={`awards.outSchool`} isRead={true} type={'awards'} />
                            </div>

                            <h2 className={style.sectionTitle}>6-3. Certificate of Appointment</h2>
                            <div className={style.sectionContent}>
                                <AwardsTable register={register} control={control} name={`awards.certificate`} isRead={true} type={'certificate'} />
                            </div>
                        </div>

                        {/* 7. Extracurricular Activities */}
                        <div className={`${style.section} extracurricular`}>
                            <h2 className={style.sectionTitle}>7. Extracurricular Activities</h2>

                            <div className={style.sectionContent}>
                                <ExtracurricularTable register={register} control={control} isRead={true} />
                            </div>
                        </div>

                        {/* 8. Exploratory Activities */}
                        <div className={`${style.section} exploratory`}>
                            <h2 className={style.sectionTitle}>8. Exploratory Activities</h2>

                            <div className={style.sectionContent}>
                                <ExploratoryTable register={register} control={control} isRead={true} />
                            </div>
                        </div>

                        {/* 9. Volunteer work */}
                        <div className={`${style.section} volunteer`}>
                            <h2 className={style.sectionTitle}>9. Volunteer work</h2>

                            <div className={style.sectionContent}>
                                <VolunteerTable register={register} control={control} isRead={true} />
                            </div>
                        </div>

                        {/* 10. Behavioral Remark and Overall Evaluation */}
                        <div className={`${style.section} behavioral`}>
                            <h2 className={style.sectionTitle}>10. Behavioral Remark and Overall Evaluation</h2>

                            <div className={style.sectionContent}>
                                <BehavioralRemarkTable register={register} control={control} isRead={true} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <hr className='divider-row' />

            <div className='py-3'>
                <label className="form-label pb-3">선생님 의견</label>
                <AdditionalComments register={register} control={control} isRead={true} />
            </div>
        </form>
    )
}

export default SchoolRecordVer2ReadForm